import React from 'react';
import { Calendar } from 'primereact/calendar';
import moment from 'moment/moment';
import { CalendarIcon } from '../../icons';

const DatePickerInstance = ({ selectedDate, updateDate, placeholder }) => {
	const selected = selectedDate ? moment(selectedDate).toDate() : '';

	const _updateDate = ({ value }) => {
		if (value) {
			updateDate(moment(value).format('MM/DD/YYYY'));
		}
	};

	const onClear = () => updateDate(null);

	return (
		<Calendar
			value={selected}
			onChange={_updateDate}
			onClearButtonClick={onClear}
			dateFormat="mm/dd/yy"
			icon={<CalendarIcon width={18} height={18} className="calendar-icon" color="#000000" />}
			showIcon
			panelClassName="credential-modal-date-picker"
			placeholder={placeholder || 'Select...'}
			showButtonBar
		/>
	);
};

export default DatePickerInstance;
